__turbopack_context__.v({
  "h3": "VerifyAccountModal-module__Lff1wq__h3",
  "h6": "VerifyAccountModal-module__Lff1wq__h6",
  "submitButton": "VerifyAccountModal-module__Lff1wq__submitButton",
  "verifyAccountModal": "VerifyAccountModal-module__Lff1wq__verifyAccountModal",
});
